import UPBreadcrumbs from './UPBreadcrumbs';

export default UPBreadcrumbs;
